import cookie from 'js-cookie';

import { MARKET_SEGMENT_COOKIE } from '~/features/cookies/constants';

export function getUserGtmCookie(): string | undefined {
  const marketSegments = cookie.get(MARKET_SEGMENT_COOKIE);

  // If the cookie exists, it will be a comma-separated list of market segments
  if (marketSegments && typeof marketSegments === 'string') {
    return marketSegments;
  }

  return;
}
